import { ConfigScope } from '../types'
import type { ConfigScopeFields } from '../types'

export function deriveConfigScope(config: ConfigScopeFields): ConfigScope | null {
  const { tenantCode, inventorySystemProfileCode, venueId } = config

  if (!tenantCode && inventorySystemProfileCode && !venueId) {
    return ConfigScope.IspConfig
  }
  if (tenantCode && !inventorySystemProfileCode && !venueId) {
    return ConfigScope.TenantConfig
  }
  if (tenantCode && inventorySystemProfileCode && !venueId) {
    return ConfigScope.TenantIspConfig
  }
  if (tenantCode && !inventorySystemProfileCode && venueId) {
    return ConfigScope.TenantVenueConfig
  }

  return null
}
